import { checkCondition2 } from '@/shared/_legacy_/condition-utils';
import { AssetDto, AssetExcludedFields } from '@/shared/lib/sj-orm';
import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';

import { FormConfig } from '../hooks/useFormFields';

type Params = {
  formData: FormConfig;
  asset: AssetDto;
  excludedFields?: AssetExcludedFields;
};

export const createAssetFieldFilter = ({ formData, asset, excludedFields }: Params) => {
  return (key: keyof AssetDto) => {
    const fieldDef = formData[key];
    if (!fieldDef) return false;

    const isExcluded =
      (excludedFields && excludedFields.includes(key)) || key.startsWith('add-new');
    const isFieldArray = fieldDef.type === QuestionType.CO_OWNERS;
    const isConditionalHidden = fieldDef.showIf && !checkCondition2(asset, fieldDef.showIf);

    return !isExcluded && !isFieldArray && !isConditionalHidden;
  };
};
